import React from "react";
import { Button } from "react-bootstrap";

export const UiSpaceLeft = (props) => {
    return (
        <>
            <div className="sb-space-card">
                <div>
                    {
                        props.title && <h4>{props.title}</h4>
                    }
                    {
                        props.spcButton && <Button onClick={props.spcButtonAction}>{props.spcButton}</Button>
                    }
                </div>
            </div>
        </>
    )
}